import { EUnitPermissionAreas } from "@m7-health/shared-utils";

export enum EUserTypes {
  staff = "staff",
  scheduler = "scheduler",
  existingScheduler = "existingScheduler",
}

export enum ESchedulerFormNames {
  firstName = "firstName",
  lastName = "lastName",
  email = "email",
  phoneNumber = "phoneNumber",
  unitAssignment = "unitAssignment",
  permissionsByUnit = "permissionsByUnit",
  permissionsByFacility = "permissionsByFacility",
}

export const facilityLevelPermissionAreas = [
  EUnitPermissionAreas.schedulerRoster,
  EUnitPermissionAreas.shiftReports,
];
